
export const UI_CHANGE_COLLAPSED_STATE = ' [ UI ACTIONS ] UI Change Collapsed State'

export interface IUIChangeCollapsedState {
    type: typeof UI_CHANGE_COLLAPSED_STATE
}